/**
 * Read offices from the trigger-maintained mirror only.
 *
 * Legacy profile_data.locations may remain after an office is deleted. It is
 * deliberately ignored so reopening a form cannot recreate deleted offices.
 */
export const officeLocationsFromOrg = (
  org: Record<string, unknown> | null | undefined,
): string[] => {
  const mirror = org?.office_locations;
  return Array.isArray(mirror)
    ? mirror.filter((location): location is string => typeof location === "string")
    : [];
};
